import {Container} from "@mui/material"
import {styled} from "@mui/material/styles"

export const PlpContainerComponent = styled(Container)`
    && {
        padding: 0;
    }
`
